<div class="secondarySidebar">
  <div class="secondarySBTitle">
    <h2>{{ 'Admin Analytics' | translate }}</h2>
  </div>
  <div class="secondarySBContent">
    <ul>
      <li class="selected" [routerLink]="['/admin/self']">{{ 'Self' | translate }}</li>
      <li [routerLink]="['/admin/cloud']">{{ 'Cloud' | translate }}</li>
      <li [routerLink]="['/admin/logs']">{{ 'Logs' | translate }}</li>
      <li [routerLink]="['/admin/apps-uploaded']">{{ 'Apps Uploaded' | translate }}</li>
    </ul>
  </div>
</div>
<div id="selfWrapper" class="containerWrapper withSidebar noBG">
  <!-- <mat-progress-bar mode="indeterminate" *ngIf="PNProgress"></mat-progress-bar> -->
  <div id="titleContainer" class="innerContainerTitle">
    <h1>{{ 'Stacks Self Sales' | translate }}</h1>
  </div>
  <div id="selfContainer" class="innerContainerContent">
    <div class="gridWrapper">
      <div class="fullGrid">
        <self-trials></self-trials>
      </div>
      <div class="fullGrid">
        <self-sales></self-sales>
      </div>
      <div class="fullGrid">
        <self-trials-conversion></self-trials-conversion>
      </div>
    </div>
  </div>
</div>
